/**
 * Created by dsong on 2017/1/22.
 */

import * as types from '../mutation';
import Account from '../../services/AccountService';
const state = {
    'token': '',
    'verified': 0,
    'roles': [],
    'HeadImg': '/static/images/avatar.jpg'
};

const actions = {}
const mutations = {
    [types.ACCOUNT_CACTE_STATE](state, res) {
        state = res;
    },

    [types.ACCOUNT_DOLOGIN](state, res) {
        Object.assign(state, res);
        Account.setStoreCache(state);
    },

    [types.ACCOUNT_UPDATE_PROFILE](state, profile) {
        Object.assign(state, profile);
        Account.setStoreCache(state);
    },

    [types.ACCOUNT_UPDATE_TOKEN](state, token) {
        Object.assign(state, {token: token});
        Account.setStoreCache(state);
    }
}

const getters = {
    accountToken() {
        return state.token;
    },
    accountId() {
        return state.id;
    },
    isVerified() {
        return state.verified === 1;
    },
    account() {
        return state;
    },
    roleIsAdmin() {
        return state.roles.some((role) => {
            return ['administrator'].indexOf(role.slug) >= 0;
        });
    },
    roleIsAdministrator() {
        return state.roles.some((role) => {
            return ['administrator'].indexOf(role.slug) >= 0;
        });
    },
    roleSlugs() {
        return state.roles.map((role) => {
            return role.slug;
        });
    }
}

export default {
    actions,
    mutations,
    getters,
    state
};



// WEBPACK FOOTER //
// ./src/store/modules/account.js